import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchSubjects,
  deleteSubject,
} from "../redux/subjectThunk";
import {
  setEditingSubject,
  setShowForm,
  clearEdit,
} from "../redux/subjectSlice";
import TableComponent from "../../table/tableComponent"; // adjust if needed
import Popup from "../../Popup"; // adjust if your path differs
import SubjectForm from "./createSubject"; // createSubject is the form

const ViewSubject = () => {
  const dispatch = useDispatch();
  const {
    subjects,
    loading,
    showForm,
  } = useSelector((state) => state.subject);

  useEffect(() => {
    dispatch(fetchSubjects());
  }, [dispatch]);

  const handleCreateNew = () => {
    dispatch(clearEdit());
    dispatch(setShowForm(true));
  };

  const handleEdit = (subject) => {
    dispatch(setEditingSubject(subject));
    dispatch(setShowForm(true));
  };

  const handleDelete = async (subject) => {
    const confirm = window.confirm(`Delete subject "${subject.subject_name}"?`);
    if (!confirm) return;

    try {
      await dispatch(deleteSubject(subject.subject_id)).unwrap();
      alert("Subject deleted successfully");
    } catch (err) {
      alert("Error deleting subject: " + err.message);
    }
  };

  const tableColumns = [
    { Header: "S. No", accessor: "sno" },
    { Header: "Subject Name", accessor: "subject_name" },
    { Header: "Class Names", accessor: "class_names" },
    { Header: "Actions", accessor: "actiontd" },
  ];

  const processData = (data) =>
    data.map((sub, idx) => ({
      ...sub,
      sno: idx + 1,
      actiontd: (
        <>
          <i
            className="fa fa-pencil mx-2"
            style={{ color: "green", cursor: "pointer" }}
            title="Edit"
            onClick={() => handleEdit(sub)}
          />
          <i
            className="fa fa-trash mx-2"
            style={{ color: "red", cursor: "pointer" }}
            title="Delete"
            onClick={() => handleDelete(sub)}
          />
        </>
      ),
    }));

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          position: "relative",
        }}
      >
        <h2 style={{  textAlign: "center" }}>Subject List</h2>
        <button
          onClick={handleCreateNew}
          style={{
            position: "absolute",
            right: 0,
            backgroundColor: "blue",
            color: "#fff",
            padding: "6px 12px",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Create Subject
        </button>
      </div>

      {loading ? (
        <p>Loading subjects...</p>
      ) : (
        <TableComponent tableColumns={tableColumns} tableData={processData(subjects)} />
      )}

      {showForm && (
        <Popup
          title="Add/Edit Subject"
          onClose={() => {
            dispatch(clearEdit());
            dispatch(setShowForm(false));
          }}
          maxWidth="600px"
          minHeight="400px"
        >
          <SubjectForm />
        </Popup>
      )}
    </div>
  );
};

export default ViewSubject;
